// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ozplWIbSrYfV02DnBFk1 {
  width: 100%;
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 45px;
  padding-top: 8px;
  position: relative;
  z-index: 0;
  /* overflow-y: scroll; */
  /* overflow-x: hidden; */
  overscroll-behavior-x: none;
  overscroll-behavior-y: contain;
  scrollbar-width: none;
  -webkit-overflow-scrolling: auto;
  touch-action: pan-y;
}
.ozplWIbSrYfV02DnBFk1[data-collapsed='true'] {
  padding-top: 17px;
}
.ozplWIbSrYfV02DnBFk1[data-has-many='false'] {
  padding-top: 0;
  gap: 40px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .ozplWIbSrYfV02DnBFk1 {
    gap: 28px;
  }
  .ozplWIbSrYfV02DnBFk1[data-has-many='false'] {
    gap: 26px;
  }
  .ozplWIbSrYfV02DnBFk1[data-has-many='true'][data-collapsed='true'] {
    padding-top: 9px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .ozplWIbSrYfV02DnBFk1[data-has-many='true'][data-collapsed='true'] {
    padding-top: 12px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .ozplWIbSrYfV02DnBFk1[data-has-many='true'][data-collapsed='true'] {
    padding-top: 12px;
  }
}
}
}
}
/* Clearance for whichever fixed bar sits at the bottom lives here, inside the scrolling
   content — as a real flex item rather than padding, because WebKit/iOS leaves a scroll
   container's own end padding out of the scrollable area (the same trap as padding-right
   on the horizontal carousels). Non-campaign-only views clear the lobby bars (fullscreen:
   StatusBar + Navigation; ingame: Navigation only), sized via --lobby-bars-height.
   Campaign-only views (opened straight from the cup) render no lobby navigation, but do
   render the fixed IngameCampaignNavigation island, so they clear that instead, sized via
   --campaign-ingame-nav-height. */
[data-campaign-only='false'] .ozplWIbSrYfV02DnBFk1::after {
  content: '';
  flex: 0 0 var(--lobby-bars-height);
  width: 100%;
}
[data-campaign-only='true'] .ozplWIbSrYfV02DnBFk1::after {
  content: '';
  flex: 0 0 var(--campaign-ingame-nav-height);
  width: 100%;
}
/* Ingame styles */
[data-open-type='ingame'] .ozplWIbSrYfV02DnBFk1 {
  background: var(--black);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  scrollbar-width: inherit;
  -webkit-overflow-scrolling: auto;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/views/css/SingleViewCampaign.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;AACF;AACA;AAAA;EACE;IACE,iBAAiB;EACnB;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,iBAAiB;EACnB;AACF;AAAA;AAAA;AAAA;AACA;;;;;;;kCAOkC;AAClC;EACE,WAAW;EACX,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,WAAW;EACX,2CAA2C;EAC3C,WAAW;AACb;AACA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,gCAAgC;AAClC","sourcesContent":[".singleViewCampaignContainer {\n  width: 100%;\n  /* height: 100%; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 45px;\n  padding-top: 8px;\n  position: relative;\n  z-index: 0;\n  /* overflow-y: scroll; */\n  /* overflow-x: hidden; */\n  overscroll-behavior-x: none;\n  overscroll-behavior-y: contain;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: auto;\n  touch-action: pan-y;\n}\n.singleViewCampaignContainer[data-collapsed='true'] {\n  padding-top: 17px;\n}\n.singleViewCampaignContainer[data-has-many='false'] {\n  padding-top: 0;\n  gap: 40px;\n}\n@media (--campaign-mobile) {\n  .singleViewCampaignContainer {\n    gap: 28px;\n  }\n  .singleViewCampaignContainer[data-has-many='false'] {\n    gap: 26px;\n  }\n  .singleViewCampaignContainer[data-has-many='true'][data-collapsed='true'] {\n    padding-top: 9px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .singleViewCampaignContainer[data-has-many='true'][data-collapsed='true'] {\n    padding-top: 12px;\n  }\n}\n/* Clearance for whichever fixed bar sits at the bottom lives here, inside the scrolling\n   content — as a real flex item rather than padding, because WebKit/iOS leaves a scroll\n   container's own end padding out of the scrollable area (the same trap as padding-right\n   on the horizontal carousels). Non-campaign-only views clear the lobby bars (fullscreen:\n   StatusBar + Navigation; ingame: Navigation only), sized via --lobby-bars-height.\n   Campaign-only views (opened straight from the cup) render no lobby navigation, but do\n   render the fixed IngameCampaignNavigation island, so they clear that instead, sized via\n   --campaign-ingame-nav-height. */\n[data-campaign-only='false'] .singleViewCampaignContainer::after {\n  content: '';\n  flex: 0 0 var(--lobby-bars-height);\n  width: 100%;\n}\n[data-campaign-only='true'] .singleViewCampaignContainer::after {\n  content: '';\n  flex: 0 0 var(--campaign-ingame-nav-height);\n  width: 100%;\n}\n/* Ingame styles */\n[data-open-type='ingame'] .singleViewCampaignContainer {\n  background: var(--black);\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-gutter: stable;\n  scrollbar-width: inherit;\n  -webkit-overflow-scrolling: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"singleViewCampaignContainer": `ozplWIbSrYfV02DnBFk1`
};
export default ___CSS_LOADER_EXPORT___;
